import React from 'react';
import './loader.scss';
import PropTypes from 'prop-types';
import colors from '../../theme/colors';

const Loader = ({ sizeScale = 1 }) => (
  <div
    style={{
      height: '100px',
      width: '100%',
      display: 'flex',
      position: 'sticky',
      textAlign: 'center',
    }}
  >
    <div style={{ transform: `scale(${sizeScale})` }} className="loading">
      <div
        style={{
          width: '2rem',
          height: '2rem',
          border: '3px solid #e5e7eb',
          borderTopColor: colors.primary,
          borderRadius: '50%',
          animation: 'spin 0.6s linear infinite',
        }}
      />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  </div>
);

Loader.propTypes = {
  sizeScale: PropTypes.number,
};

export default Loader;
